import BodyText from "../../../components/BodyText";

const InfoText = () => (
  <BodyText color="white">
    Thank you for joining COSMO! Your JrTrack and COSMO membership are now active.
    <br />
    A confirmation email has also been sent with your new phone number.
  </BodyText>
);

export default InfoText;
